export default "__VITE_ASSET__CYE5_Pzy__"